import React, { useEffect, useMemo } from 'react'
import { useDispatch, batch } from 'react-redux'

import { 
  setMonitorUserPosition, 
  useMonitorUserPosition, 
  useUserIsOnTrail,
  useUserIsNearTrail,
  useUserPosition } from '../slices/userposition'
import { addMessage } from '../slices/ui'

import {
  POSITION_RELATIVE_STATS
} from '../trans'



import HikerIcon from '../icons/hiker.svg'

const UserPositionControl = () => {

  const dispatch = useDispatch()
  const isActive = useMonitorUserPosition()
  const userPosition = useUserPosition()
  const isNearTrail = useUserIsNearTrail()
  const isOnTrail = useUserIsOnTrail()

  if (!isNearTrail) return null

  let cls = ["button circular fa"]

  if (isActive){
    cls.push('pulse')
    if (isOnTrail){
      cls.push('positive')
    } else {
      cls.push('negative')
    }
  } else {
    cls.push('secondary')
  }

  const toggleIsActive = () => batch(()=>{
    dispatch(setMonitorUserPosition(!isActive))
    if (!isActive && isOnTrail) {
      dispatch(addMessage({
        message: POSITION_RELATIVE_STATS,
        status: 'info',
        timeout: 4
      }))
    }
  })

  const className = cls.join(" ")

  return(
    <div className="pwa__userposition__control fade-in delay">
      <button className={className}
        onClick={toggleIsActive}>
        <HikerIcon/>
      </button>
    </div>
  )
}

export default UserPositionControl
